import React from "react";
import Nav from "../../../components/Nav";
import "../../../css/Home.css";
import { Outlet } from "react-router-dom";
import RegisterNav from "./RegisterNav";

export default function RegisterLayout() {
  return (
    <>
      <Nav />

      <div className="flex items-center justify-center mt-6">
        <div className="w-full max-w-4xl p-0">
          <RegisterNav />
          <Outlet />
        </div>
      </div>
    </>
  );
}
